import { defineMessages } from "react-intl";

const ACCOUNT_BENEFITS = "account-benefits";

const accountBenefitsMessages = defineMessages({
  accountBenefits: {
    id: `${ACCOUNT_BENEFITS}.account-benefits`,
    defaultMessage: "Account benefits"
  },
  syncWithMobileApp: {
    id: `${ACCOUNT_BENEFITS}.sync-with-mobile-app`,
    defaultMessage: "Sync with the mobile app"
  },
  syncWithMobileAppDescription: {
    id: `${ACCOUNT_BENEFITS}.sync-with-mobile-app-description`,
    defaultMessage:
      "Take your research on the go. Search, read and listen in the app!"
  },
  iOS: {
    id: `${ACCOUNT_BENEFITS}.ios`,
    defaultMessage: "iOS",
    description: "Text for link to download EBSCO Mobile App for iOS devices"
  },
  android: {
    id: `${ACCOUNT_BENEFITS}.android`,
    defaultMessage: "Android",
    description:
      "Text for link to download EBSCO Mobile App for Android devices"
  },
  downloadEBooks: {
    id: `${ACCOUNT_BENEFITS}.download-ebooks`,
    defaultMessage: "Download eBooks"
  },
  downloadEBooksDescription: {
    id: `${ACCOUNT_BENEFITS}.download-ebooks-description`,
    defaultMessage: "Access thousands of eBook titles to read and download."
  },
  createProjects: {
    id: `${ACCOUNT_BENEFITS}.create-projects`,
    defaultMessage: "Create projects"
  },
  createProjectsDescription: {
    id: `${ACCOUNT_BENEFITS}.create-projects-description`,
    defaultMessage: "Keep your research organized within custom projects."
  },
  saveYourResearch: {
    id: `${ACCOUNT_BENEFITS}.save-your-research`,
    defaultMessage: "Save your research"
  },
  saveYourResearchDescription: {
    id: `${ACCOUNT_BENEFITS}.save-your-research-description`,
    defaultMessage: "Never lose your search queries, or documents again."
  }
});

export default accountBenefitsMessages;
